/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import {
	Notify
} from 'vant';
import router from '../router/index'
// 环境的切换
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';


// 请求拦截器
axios.interceptors.request.use(
	config => {
		return config;
	},
	error => {
		return Promise.error(error);
	})
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err)
			})
	});
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
	// console.log(params)
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err)
			})
	});
}

/** 
 * put方法，对应put请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function put(url, params) {
	// console.log(params)
	return new Promise((resolve, reject) => {
		axios.put(url, params)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err)
			})
	});
}

/** 
 * delete方法，对应delete请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function delet(url, params) {
	// console.log(params)
	return new Promise((resolve, reject) => {
		axios.delete(url, params)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err)
			})
	});
}

//检验token是否过期
export let checkAuthonToken = () => {
	return new Promise((resolve, reject) => {
		axios.get('https://unified.cacpaper.com/unified-platform-server-api/user/get/check/' + localStorage.getItem('authToken'))
			.then(res => {
				if (res.data.success) {
					localStorage.setItem('userInfo', JSON.stringify(res.data.data))
					return resolve(true)
				}
				if (!res.data.success) {
					return reject(false)
				}
			})
			.catch(err => {
				return reject(false)
			})
	});
}

//清除token
export let logoOut = () => {
	return new Promise((resolve, reject) => {
		axios.post('https://unified.cacpaper.com/unified-platform-server-api/user/logout', "token=" + localStorage.getItem('authToken'), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then(res => {
			if (res.data.success) {
				localStorage.clear()
				return resolve(true)
			}
		}).catch(err => {
			return reject(false)
		})
	});
}
